{
  "cross-flow-jpd-notify-continue-set-up.notification.primary.action": [
    {
      "type": 0,
      "value": "Finish setup"
    }
  ],
  "cross-flow-jpd-notify-continue-set-up.notification.secondary.action": [
    {
      "type": 0,
      "value": "Start a new project"
    }
  ],
  "cross-flow-jpd-notify-continue-set-up.notification.title": [
    {
      "type": 0,
      "value": "Finish setting up "
    },
    {
      "type": 1,
      "value": "templateName"
    }
  ],
  "cross-flow-jsm-notify-continue-set-up.notification.body": [
    {
      "type": 0,
      "value": "85% of users find that using Jira with Jira Service Management makes it easier to coordinate and resolve requests."
    }
  ],
  "cross-flow-jsm-notify-continue-set-up.notification.generic.title": [
    {
      "type": 0,
      "value": "Finish setting up "
    },
    {
      "type": 1,
      "value": "templateName"
    }
  ],
  "cross-flow-jsm-notify-continue-set-up.notification.primary.action": [
    {
      "type": 0,
      "value": "Finish setup"
    }
  ],
  "cross-flow-jsm-notify-continue-set-up.notification.secondary.action": [
    {
      "type": 0,
      "value": "Start a new project"
    }
  ],
  "cross-flow-jsm-notify-continue-set-up.notification.specific.title": [
    {
      "type": 0,
      "value": "Finish setting up your "
    },
    {
      "type": 1,
      "value": "templateName"
    },
    {
      "type": 0,
      "value": " project"
    }
  ],
  "cross-flow-product-notification-added-new-product.message.jira.product.discovery.body": [
    {
      "type": 0,
      "value": "Jira Product Discovery has been added to your site. Use it to capture, prioritize, and roadmap ideas."
    }
  ],
  "cross-flow-product-notification-added-new-product.message.jira.servicedesk.ondemand.body": [
    {
      "type": 0,
      "value": "Jira Service Management has been added to your site. Use it to receive, track, and manage requests."
    }
  ],
  "cross-flow-product-notification-added-new-product.message.path.link.label": [
    {
      "type": 0,
      "value": "Atlassian Administration"
    }
  ],
  "cross-flow-product-notification-added-new-product.message.title": [
    {
      "type": 1,
      "value": "actorName"
    },
    {
      "type": 0,
      "value": " added "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "cross-flow-product-notification-added-new-product.request.primary.action.label": [
    {
      "type": 0,
      "value": "View project"
    }
  ],
  "cross-flow-product-notification-added-new-product.request.secondary.action.label": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "cross-flow-product-request-approval.message.title": [
    {
      "type": 0,
      "value": "Your request to try "
    },
    {
      "type": 1,
      "value": "product_name"
    },
    {
      "type": 0,
      "value": " has been approved!"
    }
  ],
  "cross-flow-product-request-reminder.message.com.atlassian.service.collection.body": [
    {
      "type": 0,
      "value": "Service Collection helps your teams deliver exceptional service experiences for employees and customers through a single platform."
    }
  ],
  "cross-flow-product-request-reminder.message.confluence.ondemand.body": [
    {
      "type": 0,
      "value": "Confluence is a single place for all documentation and it seamlessly links to Jira. It’s free to try and cancel anytime."
    }
  ],
  "cross-flow-product-request-reminder.message.jira.product.discovery.body": [
    {
      "type": 0,
      "value": "Jira Product Discovery is a roadmap and prioritization tool that links to your business or software projects."
    }
  ],
  "cross-flow-product-request-reminder.message.jira.servicedesk.ondemand.body": [
    {
      "type": 0,
      "value": "Jira Service Management links to your business or software projects to receive and manage requests."
    }
  ],
  "cross-flow-product-request-reminder.message.path.link.label": [
    {
      "type": 0,
      "value": "Atlassian Administration"
    }
  ],
  "cross-flow-product-request-reminder.message.title": [
    {
      "type": 0,
      "value": "Action required: "
    },
    {
      "type": 1,
      "value": "requestor_name"
    },
    {
      "type": 0,
      "value": " is waiting for your approval to try "
    },
    {
      "type": 1,
      "value": "product_name"
    }
  ],
  "cross-flow-product-request-reminder.message.title.doublerequestors": [
    {
      "type": 0,
      "value": "Action required: "
    },
    {
      "type": 1,
      "value": "requestor_name"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "previous_requestor_name"
    },
    {
      "type": 0,
      "value": " are waiting for your approval to try "
    },
    {
      "type": 1,
      "value": "product_name"
    }
  ],
  "cross-flow-product-request-reminder.message.title.multirequestors": [
    {
      "type": 0,
      "value": "Action required: "
    },
    {
      "type": 1,
      "value": "requestor_name"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "previous_requestor_count"
    },
    {
      "type": 0,
      "value": " others are waiting for your approval to try "
    },
    {
      "type": 1,
      "value": "product_name"
    }
  ],
  "cross-flow-product-request-reminder.request.primary.action.label": [
    {
      "type": 0,
      "value": "Start free"
    }
  ],
  "cross-flow-product-request-reminder.request.secondary.action.label": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "cross-flow-product-request.message.path.link.label": [
    {
      "type": 0,
      "value": "Atlassian Administration"
    }
  ],
  "cross-flow-product-request.message.title": [
    {
      "type": 0,
      "value": "Approve app request from "
    },
    {
      "type": 1,
      "value": "actorName"
    }
  ],
  "cross-flow-product-request.request.primary.action.label": [
    {
      "type": 0,
      "value": "Start free"
    }
  ],
  "cross-flow-product-request.request.primary.action.review.label": [
    {
      "type": 0,
      "value": "Review request"
    }
  ],
  "cross-flow-product-request.request.secondary.action.label": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "cross-flow-product-store-recommendations.confluence.body": [
    {
      "type": 0,
      "value": "Create consistency with award-winning page templates."
    }
  ],
  "cross-flow-product-store-recommendations.confluence.title": [
    {
      "type": 0,
      "value": "Content creation"
    }
  ],
  "cross-flow-product-store-recommendations.jira.body": [
    {
      "type": 0,
      "value": "Visualize work with custom workflow, lists, boards, backlogs, and more."
    }
  ],
  "cross-flow-product-store-recommendations.jira.title": [
    {
      "type": 0,
      "value": "Plan and track work"
    }
  ],
  "cross-flow-product-store-recommendations.jpd.product-discovery.body": [
    {
      "type": 0,
      "value": "Prioritize ideas then connect them from discovery through to delivery."
    }
  ],
  "cross-flow-product-store-recommendations.jpd.product-discovery.title": [
    {
      "type": 0,
      "value": "Product discovery"
    }
  ],
  "cross-flow-product-store-recommendations.jpd.product-roadmap.body": [
    {
      "type": 0,
      "value": "Create custom roadmaps and share your plans with anyone."
    }
  ],
  "cross-flow-product-store-recommendations.jpd.product-roadmap.title": [
    {
      "type": 0,
      "value": "Product roadmap"
    }
  ],
  "cross-flow-product-store-recommendations.jsm.analytics-service-management.body": [
    {
      "type": 0,
      "value": "Help employees access and request the data and analytics they need."
    }
  ],
  "cross-flow-product-store-recommendations.jsm.analytics-service-management.title": [
    {
      "type": 0,
      "value": "Analytics service management"
    }
  ],
  "cross-flow-product-store-recommendations.jsm.customer-service-management.body": [
    {
      "type": 0,
      "value": "Help your customers easily raise requests, report problems, and get support."
    }
  ],
  "cross-flow-product-store-recommendations.jsm.customer-service-management.title": [
    {
      "type": 0,
      "value": "Customer service management"
    }
  ],
  "cross-flow-product-store-recommendations.jsm.design-service-management.body": [
    {
      "type": 0,
      "value": "Manage employee requests for designs, reviews, and any other request."
    }
  ],
  "cross-flow-product-store-recommendations.jsm.design-service-management.title": [
    {
      "type": 0,
      "value": "Design service management"
    }
  ],
  "cross-flow-product-store-recommendations.jsm.facilities-service-management.body": [
    {
      "type": 0,
      "value": "Easily manage requests for maintenance, moving, and event planning."
    }
  ],
  "cross-flow-product-store-recommendations.jsm.facilities-service-management.title": [
    {
      "type": 0,
      "value": "Facilities service management"
    }
  ],
  "cross-flow-product-store-recommendations.jsm.finance-service-management.body": [
    {
      "type": 0,
      "value": "Easily manage and track budget, spend, and any other finance request."
    }
  ],
  "cross-flow-product-store-recommendations.jsm.finance-service-management.title": [
    {
      "type": 0,
      "value": "Finance service management"
    }
  ],
  "cross-flow-product-store-recommendations.jsm.general-service-management.body": [
    {
      "type": 0,
      "value": "Create one place to collect and manage any type of request."
    }
  ],
  "cross-flow-product-store-recommendations.jsm.general-service-management.title": [
    {
      "type": 0,
      "value": "General service management"
    }
  ],
  "cross-flow-product-store-recommendations.jsm.hr-service-management.body": [
    {
      "type": 0,
      "value": "Simplify onboarding, off-boarding, and any other HR request."
    }
  ],
  "cross-flow-product-store-recommendations.jsm.hr-service-management.title": [
    {
      "type": 0,
      "value": "HR service management"
    }
  ],
  "cross-flow-product-store-recommendations.jsm.it-service-management.body": [
    {
      "type": 0,
      "value": "Quickly respond to requests, resolve incidents, and deploy changes."
    }
  ],
  "cross-flow-product-store-recommendations.jsm.it-service-management.title": [
    {
      "type": 0,
      "value": "IT service management"
    }
  ],
  "cross-flow-product-store-recommendations.jsm.legal-service-management.body": [
    {
      "type": 0,
      "value": "Easily manage requests about contracts, policies, and more."
    }
  ],
  "cross-flow-product-store-recommendations.jsm.legal-service-management.title": [
    {
      "type": 0,
      "value": "Legal service management"
    }
  ],
  "cross-flow-product-store-recommendations.jsm.marketing-service-management.body": [
    {
      "type": 0,
      "value": "Manage employee requests for assets, reviews, and any other marketing request."
    }
  ],
  "cross-flow-product-store-recommendations.jsm.marketing-service-management.title": [
    {
      "type": 0,
      "value": "Marketing service management"
    }
  ],
  "cross-flow-product-store-recommendations.jsm.sales-service-management.body": [
    {
      "type": 0,
      "value": "Easily manage requests for quote support, contract reviews, and more."
    }
  ],
  "cross-flow-product-store-recommendations.jsm.sales-service-management.title": [
    {
      "type": 0,
      "value": "Sales service management"
    }
  ],
  "cross-flow.components.product-store-template-card.template-image-alt-text": [
    {
      "type": 0,
      "value": "A document titled quarterly planning. The document has details like mission, scope and a monthly plan."
    }
  ],
  "cross-flow.components.product-store-template-card.template-try-cta-button-text": [
    {
      "type": 0,
      "value": "Try template"
    }
  ],
  "cross-flow.cross-flow-product-request-approval.action": [
    {
      "type": 0,
      "value": "Go to Jira Product Discovery"
    }
  ],
  "cross-flow.cross-flow-product-request-approval.description": [
    {
      "type": 0,
      "value": "Prioritize ideas, build living roadmaps, and connect to delivery in Jira."
    }
  ],
  "cross-flow.cross-flow-product-request-approval.title": [
    {
      "type": 0,
      "value": "Your access to Jira Product Discovery has been approved"
    }
  ],
  "cross-flow.cross-flow-product-request.screen-space-flags.action.get-started": [
    {
      "type": 0,
      "value": "Get started"
    }
  ],
  "cross-flow.cross-flow-product-request.screen-space-flags.action.remind-me-later": [
    {
      "type": 0,
      "value": "Remind me later"
    }
  ],
  "cross-flow.cross-flow-product-request.screen-space-flags.action.review-request": [
    {
      "type": 0,
      "value": "Review request"
    }
  ],
  "cross-flow.cross-flow-product-request.screen-space-flags.description": [
    {
      "type": 1,
      "value": "requesterName"
    },
    {
      "type": 0,
      "value": " sent a request to try "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": ". It's free to try. Cancel any time."
    }
  ],
  "cross-flow.cross-flow-product-request.screen-space-flags.title": [
    {
      "type": 0,
      "value": "Approve a request to try "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "cross-flow.xflow-notification-end-user-added-loom.message-template.email.subject": [
    {
      "type": 0,
      "value": "🎉 "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " has started using Loom"
    }
  ],
  "cross-flow.xflow-notification-end-user-added-loom.message.email.admin-url.no-translate": [
    {
      "type": 0,
      "value": "admin.atlassian.com"
    }
  ],
  "cross-flow.xflow-notification-end-user-added-loom.message.email.footer.icon.alt": [
    {
      "type": 0,
      "value": "Atlassian Logo"
    }
  ],
  "cross-flow.xflow-notification-end-user-added-loom.message.email.get-started.button": [
    {
      "type": 0,
      "value": "Get started"
    }
  ],
  "cross-flow.xflow-notification-end-user-added-loom.message.email.header.icon.alt": [
    {
      "type": 0,
      "value": "Loom Logo"
    }
  ],
  "cross-flow.xflow-notification-end-user-added-loom.message.email.headline": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " has started using Loom!"
    }
  ],
  "cross-flow.xflow-notification-end-user-added-loom.message.email.instance-url.no-translate": [
    {
      "type": 1,
      "value": "instanceUrl"
    }
  ],
  "cross-flow.xflow-notification-end-user-added-loom.message.email.lead-paragraph": [
    {
      "type": 0,
      "value": "Loom has been added to "
    },
    {
      "type": 1,
      "value": "instanceURL"
    },
    {
      "type": 0,
      "value": ". You don’t need to do anything. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Invite up to 10 members, for free."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " You can cancel any time at "
    },
    {
      "type": 1,
      "value": "adminURL"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "cross-flow.xflow-notification-end-user-added-loom.message.email.sent-by-atlassian": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Cloud"
    }
  ],
  "cross-flow.xflow-notification-end-user-added-loom.message.email.value-prop.communication": [
    {
      "type": 0,
      "value": "🚀 Explore Loom and see how it can transform your team's communication and collaboration."
    }
  ],
  "cross-flow.xflow-notification-end-user-added-loom.message.email.value-prop.efficiency": [
    {
      "type": 0,
      "value": "⏱️ Teams using Loom report a 29% reduction in meetings and a 74% increase in efficiency."
    }
  ],
  "cross-flow.xflow-notification-end-user-added-loom.message.email.value-prop.share-video": [
    {
      "type": 0,
      "value": "📹 Loom allows teams to create and share video messages effortlessly."
    }
  ]
}